import React, { useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import Spinner from "components/Loader/Spinner";
import {
  registerActivePlayback,
  unregisterActivePlayback,
} from "util/audioPlaybackRegistry";

const RecordedWaveform = ({ blobURL, className = "", feedBack = false }) => {
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    if (blobURL && waveformRef.current) {
      if (wavesurfer.current) {
        wavesurfer.current.destroy();
      }

      setIsReady(false);
      setIsPlaying(false);
      setIsLoading(true);
      setDuration(0);
      setCurrentTime(0);

      wavesurfer.current = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: "#008000",
        progressColor: "#DA2C43",
        cursorWidth: 0,
        cursorHeight: 0,
        barWidth: 2,
        barRadius: 2,
        barHeight: 4,
        height: 50,
        responsive: true,
        plugins: [],
      });

      wavesurfer.current.on("loading", () => {
        setIsLoading(true);
      });

      wavesurfer.current.on("error", () => {
        setIsLoading(false);
        setIsReady(false);
      });

      wavesurfer.current.on("ready", () => {
        setIsLoading(false);
        setIsReady(true);
        const audioDuration = wavesurfer.current.getDuration();
        console.log("This is the Duration : ",audioDuration);
        setDuration(audioDuration);
      });

      wavesurfer.current.on("play", () => {
        setIsPlaying(true);
        registerActivePlayback(wavesurfer.current);
      });

      wavesurfer.current.on("pause", () => {
        setIsPlaying(false);
        unregisterActivePlayback(wavesurfer.current);
      });

      wavesurfer.current.on("finish", () => {
        setIsPlaying(false);
        setCurrentTime(duration);
        unregisterActivePlayback(wavesurfer.current);
      });

       wavesurfer.current.on("audioprocess", () => {
        setCurrentTime(wavesurfer.current.getCurrentTime());
      });

      
      wavesurfer.current.on("seek", () => {
        setCurrentTime(wavesurfer.current.getCurrentTime());
      });

      wavesurfer.current.load(blobURL);
    }

    return () => {
      if (wavesurfer.current) {
        unregisterActivePlayback(wavesurfer.current);
        wavesurfer.current.destroy();
        wavesurfer.current = null;
      }
    };
  }, [blobURL]);

  const handlePlayPause = () => {
    if (wavesurfer.current && isReady) {
      wavesurfer.current.playPause();
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };


  if (!blobURL) return null;

  return (
    <div className={`recorded-waveform-container position-relative ${className}`}>
      <div className="recorded-waveform-visual d-flex px-0 py-2">
        {isLoading && (
          <div className="waveform-spinner-overlay">
            <Spinner id="mocklist-spinner-tag" className="spinner-border" />
          </div>
        )}
         {/* Overlay Play / Pause Icon (Feedback Mode) */}
        {feedBack && (
          <button
            type="button"
            className="waveform-overlay-btn"
            onClick={handlePlayPause}
            disabled={!isReady}
          >
            {isPlaying ? (
              <i className="fa fa-pause"></i>
            ) : (
              <i className="fa fa-play"></i>
            )}
          </button>
        )}
        <div
          ref={waveformRef}
          className={ feedBack ? "recorded-waveform-wave-feedback": "recorded-waveform-wave"}
          style={{ outline: "none" }}
        />
        {!feedBack && <div className={ feedBack ? "waveform-base-line-feedback" : "waveform-base-line"}></div> }
      </div>
      {/* <button
        onClick={handlePlayPause}
        className="recorded-waveform-button btn btn-primary"
        disabled={!isReady}
      >
        {isPlaying ? "Pause" : "Play"}
      </button> */}
      {/* Bottom Button (Hidden in feedback mode) */}

       {isReady && duration > 0 && (
        <div className="position-absolute w-100 d-flex justify-content-center mt-2">
          <small className="text-muted">
            <span className={isPlaying ? "text-primary fw-bold" : ""}>
              {formatTime(currentTime)}
            </span>
            {" / "}
            {formatTime(duration)}
          </small>
        </div>
      )}

      {!feedBack && (
        <div className="handle-buttons">
          <button
            type="button"
            className="outline-btn pull-left text-center"
            onClick={handlePlayPause}
            disabled={!isReady}
          >
            {isPlaying ? "Pause" : "Play"}
          </button>
        </div>
      )}
    </div>
  );
};

export default RecordedWaveform;
